const typography: any = {
  fontFamily: "'Plus Jakarta Sans', sans-serif;",
  h1: {
    fontWeight: 600,
    fontSize: '2.8125rem', // 2.25 * 1.25
    lineHeight: '3.4375rem', // 2.75 * 1.25
  },
  h2: {
    fontWeight: 600,
    fontSize: '2.34375rem', // 1.875 * 1.25
    lineHeight: '2.8125rem', // 2.25 * 1.25
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.875rem', // 1.5 * 1.25
    lineHeight: '2.1875rem', // 1.75 * 1.25
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.640625rem', // 1.3125 * 1.25
    lineHeight: '2rem', // 1.6 * 1.25
  },
  h5: {
    fontWeight: 600,
    fontSize: '1.40625rem', // 1.125 * 1.25
    lineHeight: '2rem', // 1.6 * 1.25
  },
  h6: {
    fontWeight: 600,
    fontSize: '1.25rem', // 1 * 1.25
    lineHeight: '1.5rem', // 1.2 * 1.25
  },
  button: {
    textTransform: 'capitalize',
    fontWeight: 400,
  },
  body1: {
    fontSize: '1.09375rem', // 0.875 * 1.25
    fontWeight: 400,
    lineHeight: '1.6675rem', // 1.334 * 1.25
  },
  body2: {
    fontSize: '0.9375rem', // 0.75 * 1.25
    letterSpacing: '0rem',
    fontWeight: 400,
    lineHeight: '1.25rem', // 1 * 1.25
  },
  subtitle1: {
    fontSize: '1.09375rem',
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '1.09375rem',
    fontWeight: 400,
  },
};

export default typography;
